<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: String as PropType<string | null | undefined>,
    default: null,
  },

  canClear: {
    type: Boolean,
    default: false,
  },
  searchable: {
    type: Boolean,
    default: true,
  },
  placeholder: {
    type: String,
    default: "Select a checklist",
  },
  preventDefault: {
    type: Boolean,
    default: false,
  },
  widthOverride: {
    type: String,
    default: undefined,
  },
});

const emit = defineEmits(["update:modelValue"]);

const appUserDataStore = useAppUserDataStore();
const { appUser } = storeToRefs(appUserDataStore);

const userChecklistStore = useUserChecklistsStore();
const { checklists, allChecklists } = storeToRefs(userChecklistStore);

const key = ref(Date.now());

watch(checklists, () => {
  key.value = Date.now();
});

const selectKey = computed(() => {
  return `${props.modelValue ?? "n/a"}-${key.value}`;
});

const checklistsToUse = computed(() => {
  var c = [...checklists.value];

  if (props.modelValue == undefined) {
    return c;
  }

  // Does the list of checklists include the model value?
  if (c.some((c) => c.id == props.modelValue)) {
    return c;
  }

  const selectedChecklist = allChecklists.value.find(
    (c: Checklist) => c.id == props.modelValue
  );
  if (selectedChecklist) {
    c.push(selectedChecklist);
  }

  return c;
});

const sortedChecklists = computed(() => {
  return useSortChecklists(checklistsToUse.value);
});
</script>

<template>
  <BaseSelectInput
    :key="selectKey"
    :options="sortedChecklists"
    value-prop="id"
    label="title"
    :model-value="modelValue"
    :searchable="searchable"
    :can-clear="canClear"
    :prevent-default="preventDefault"
    :always-show-empty="true"
    :width-override="widthOverride"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>
    <template #empty-results>
      <BaseIconCircleDashed class="text-medium text-input-1 mr-2" />
      <span class="text-input-1 text-medium flex flex-row items-center">
        Can't find a checklist?
        <NuxtLink to="/configure/curriculum" target="_blank">
          <span class="ml-2 text-primary-default hover:underline">
            Configure here.
          </span>
        </NuxtLink>
      </span>
    </template>
  </BaseSelectInput>
</template>

<style scoped></style>
